import merge from 'lodash/merge'
import baseStyles from '../Base/Base.styles'
import { parseResponsiveProperty } from '@converdy/styles'

export default ({
  base,
  dotSize,
  itemTextColor,
  itemDotColor,
  itemIconColor,
  itemIconSize,
  itemTitleColor,
  columns,
  columnGap
}) => {

  let jss = {root:{
    ...baseStyles(base),
    '--item-title-color': itemTitleColor,
    '--item-text-color': itemTextColor,
    '--item-dot-color': itemDotColor,
    '--item-icon-color': itemIconColor
  }} 
  
  merge(jss.root, {
    ...merge(
      parseResponsiveProperty((c) => {
        return c ? {'--dot-size': `${c}px`} : {}
      }, dotSize),
      parseResponsiveProperty((c) => {
        return c ? {'--item-icon-size': `${c}px`} : {}
      }, itemIconSize),
      parseResponsiveProperty((c) => {
        return c ? {'--columns': `${c}`} : {}
      }, columns),
      parseResponsiveProperty((c) => {
        return {'--column-gap': `${c || 0}px`}
      }, columnGap)
    )
  })

  return jss

}